import { loadImageAsync } from '@meitu/saas-editor-core/es/utils/file-kit';
import { uploadBase64ToObs } from '@meitu/saas-editor-core/es/utils/upload-kit';
import { IAIExpendImageInfo } from '@/store/models/plugin-model';

const MAX_EXPEND_SIZE = 3840;

const getExpendSizeByNewSize = (
    naturalWidth: number,
    naturalHeight: number,
    newWidth: number,
    newHeight: number,
    offsetX: number,
    offsetY: number,
) => {
    return {
        left: (newWidth - naturalWidth) / 2 + offsetX,
        top: (newHeight - naturalHeight) / 2 + offsetY,
        right: (newWidth - naturalWidth) / 2 - offsetX,
        bottom: (newHeight - naturalHeight) / 2 - offsetY,
    };
};
export const getImageExpendSize = (
    naturalWidth: number,
    naturalHeight: number,
    aiExpendImageInfo: IAIExpendImageInfo,
) => {
    const { multiple, ratio, offsetX, offsetY } = aiExpendImageInfo;
    let [ratioWidth, ratioHeight] = [naturalWidth, naturalHeight];

    if (ratio !== '0') {
        [ratioWidth, ratioHeight] = ratio.split(':').map((str) => parseInt(str));
    }

    let newWidth = naturalWidth;
    let newHeight = naturalHeight;
    const width = (naturalHeight * ratioWidth) / ratioHeight;
    if (width > naturalWidth) {
        newWidth = width * multiple;
        newHeight = naturalHeight * multiple;
    } else {
        newHeight = ((naturalWidth * ratioHeight) / ratioWidth) * multiple;
        newWidth = naturalWidth * multiple;
    }

    return {
        ...getExpendSizeByNewSize(naturalWidth, naturalHeight, newWidth, newHeight, offsetX, offsetY),
        newWidth,
        newHeight,
    };
};

export const adjustImageExpendSize = async (
    naturalWidth: number,
    naturalHeight: number,
    newWidth: number,
    newHeight: number,
    url: string,
    aiExpendImageInfo: IAIExpendImageInfo,
) => {
    const { multiple, ratio, offsetX, offsetY } = aiExpendImageInfo;
    if (newWidth <= MAX_EXPEND_SIZE && newWidth <= MAX_EXPEND_SIZE) {
        return {
            naturalWidth,
            naturalHeight,
            newWidth,
            newHeight,
            ...getExpendSizeByNewSize(naturalWidth, naturalHeight, newWidth, newHeight, offsetX, offsetY),
            url,
        };
    }

    let scale = 1;
    if (newWidth > newHeight) {
        scale = MAX_EXPEND_SIZE / newWidth;
    } else {
        scale = MAX_EXPEND_SIZE / newHeight;
    }

    const img = await loadImageAsync(url);
    const canvas = document.createElement('canvas');
    canvas.width = naturalWidth * scale;
    canvas.height = naturalHeight * scale;
    const ctx = canvas.getContext('2d');
    ctx?.drawImage(img, 0, 0, naturalWidth, naturalHeight, 0, 0, naturalWidth * scale, naturalHeight * scale);
    const { url: newUrl } = await uploadBase64ToObs(canvas.toDataURL());

    return {
        naturalWidth: naturalWidth * scale,
        naturalHeight: naturalHeight * scale,
        newWidth: newWidth * scale,
        newHeight: newHeight * scale,
        ...getExpendSizeByNewSize(
            naturalWidth * scale,
            naturalHeight * scale,
            newWidth * scale,
            newHeight * scale,
            offsetX * scale,
            offsetY * scale,
        ),
        url: newUrl,
    };
};
